<template>
    <div>
        <div class="model-list">
            <!-- <component :is="`tms-type-${f.type}`" v-for="f in field.content" :field="f" :key="f.key" :config="config[field.key]"></component> -->
            <component :is="`tms-type-${f.type}`" v-for="f in field.content" :field="f" :key="f.key"  source='custom' :config="config"></component>

        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>

    /**
     * Created by huangdonglin on 2018/1/3.
     */

    export default {
        name: 'tms-type-custom',
        props: {
            field: {
                type: [Object, Array],
                required: true
            },
            // config: {
            //     type: Object,
            //     default() {
            //         return {}
            //     }
            // }
        },
        data() {
            return {}
        },
        computed: {
            config() {
                return this.$store.state.tms.customConfig;
            }
        },
        components: {
        },

        mounted() {

        },

        methods: {}
    }

</script>
